import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { publicMethods, baseUrl } from '../globals';
import { Observable } from 'rxjs/internal/Observable';
// Import finalize here
import { catchError, tap, finalize } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ResultsFormatEditorService {
  constructor(
    private http: HttpClient,
    private pubMethods: publicMethods,
    private auth: AuthenticationService
  ) {}

  isLoading = {
    isLoadingInitialData: false,
    isUpdatingAResultsFormat: false,
  };

  isLoadingSignal = signal({
    isLoadingInitialData: false,
    isUpdatingAResultsFormat: false,
  });

  getBasicUserResultsFormat(): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isLoadingInitialData: true,
    }));
    let params = new HttpParams();
    return this.http
      .post(
        baseUrl + '/get_basic_user_results_format_details/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ =>
          this.isLoadingSignal.update(state => ({
            ...state,
            isLoadingInitialData: false,
          }))
        ),
        catchError(
          this.pubMethods.handleError(
            'getBasicUserResultsFormat',
            [],
            this.isLoading
          )
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isLoadingInitialData: false,
          }));
        })
      );
  }

  getUserResultsFormat(): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isLoadingInitialData: true,
    }));
    let params = new HttpParams();
    return this.http
      .post(
        baseUrl + '/get_user_results_format_details/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ =>
          this.isLoadingSignal.update(state => ({
            ...state,
            isLoadingInitialData: false,
          }))
        ),
        catchError(
          this.pubMethods.handleError(
            'getUserResultsFormat',
            [],
            this.isLoading
          )
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isLoadingInitialData: false,
          }));
        })
      );
  }

  updateResultsFormatName(orgOrUser, resultsId, name): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isUpdatingAResultsFormat: true,
    }));
    let params = new HttpParams().set('id', resultsId).set('name', name);
    return this.http
      .post(
        // This line is now fixed. It was '/update_name_of_'a + ...
        baseUrl + '/update_name_of_' + orgOrUser + '_results_view/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        catchError(
          this.pubMethods.handleError(
            'updateResultsFormatName',
            [],
            this.isLoading
          )
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isUpdatingAResultsFormat: false,
          }));
        })
      );
  }

  createNewResultsFormat(orgOrUser, name, columns): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isUpdatingAResultsFormat: true,
    }));
    let params = new HttpParams()
      .set('columns', this.pubMethods.stringifyListForGetParams(columns))
      .set('name', name);
    return this.http
      .post(
        baseUrl + '/add_new_' + orgOrUser + '_results_view/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        catchError(
          this.pubMethods.handleError(
            'createNewResultsFormat',
            [],
            this.isLoading
          )
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isUpdatingAResultsFormat: false,
          }));
        })
      );
  }

  saveResultsFormat(orgOrUser, id, columns, name): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isUpdatingAResultsFormat: true,
    }));
    let params = new HttpParams()
      .set('id', id)
      .set('columns', this.pubMethods.stringifyListForGetParams(columns))
      .set('name', name);
    return this.http
      .post(
        baseUrl + '/update_' + orgOrUser + '_results_view/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        catchError(
          this.pubMethods.handleError('saveResultsFormat', [], this.isLoading)
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isUpdatingAResultsFormat: false,
          }));
        })
      );
  }

  selectDefaultResultsFormat(orgOrUser, id): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isUpdatingAResultsFormat: true,
    }));
    let params = new HttpParams().set('id', id);
    return this.http
      .post(
        baseUrl + '/select_' + orgOrUser + '_default_results_view/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        catchError(
          this.pubMethods.handleError(
            'selectDefaultResultsFormat',
            [],
            this.isLoading
          )
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isUpdatingAResultsFormat: false,
          }));
        })
      );
  }

  deleteResultsFormat(orgOrUser, id): Observable<any> {
    this.isLoadingSignal.update(state => ({
      ...state,
      isUpdatingAResultsFormat: true,
    }));
    let params = new HttpParams().set('id', id);
    return this.http
      .post(
        baseUrl + '/delete_' + orgOrUser + '_results_view/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        catchError(
          this.pubMethods.handleError('deleteResultsFormat', [], this.isLoading)
        ),
        finalize(() => {
          this.isLoadingSignal.update(state => ({
            ...state,
            isUpdatingAResultsFormat: false,
          }));
        })
      );
  }
}
